import { render } from "./PopupDemo.vue?vue&type=template&id=477dea1d"
import script from "./PopupDemo.vue?vue&type=script&lang=ts"
export * from "./PopupDemo.vue?vue&type=script&lang=ts"
script.render = render

export default script